import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('rest'),
  hasConnectionStatus: false,
  avatarPath: avatars.rest,
  logoPath: logos.rest
});
